(function ($) {
  'use strict';

  $(function () {

    /* ---------- Walk-in support: switch the map per location ---------- */
    var $map = $('#cu-map');
    var $mapLink = $('#cu-map-link');
    var $locs = $('.cu-loc');
    $locs.on('click', function () {
      var $loc = $(this);
      if ($loc.hasClass('is-active')) return;
      $locs.removeClass('is-active').attr('aria-pressed', 'false');
      $loc.addClass('is-active').attr('aria-pressed', 'true');
      $map.attr('title', $loc.data('title')).attr('src', $loc.data('embed'));
      $mapLink.attr('href', $loc.data('url'));
    });

    /* ---------- Support request form (posts to Shopify's native contact form) ---------- */
    var $form = $('#cu-contact-form');
    if (!$form.length) return;

    var $name = $('#cu-name');
    var $email = $('#cu-email');
    var $phone = $('#cu-phone');
    var $message = $('#cu-message');
    var $types = $('#cu-types');

    function setError($el, hasError) {
      var $field = $el.hasClass('cu-types') ? $el : $el.closest('.cu-form__field');
      $field.toggleClass('has-error', hasError);
      if (!$el.hasClass('cu-types')) $el.attr('aria-invalid', hasError ? 'true' : 'false');
      return !hasError;
    }

    $phone.on('input', function () {
      this.value = this.value.replace(/[^\d+]/g, '').slice(0, 13);
    });

    $form.on('submit', function (e) {
      e.preventDefault();

      var phoneDigits = $phone.val().replace(/^\+?91/, '');
      var results = [
        setError($name, $name.val().trim() === ''),
        setError($email, !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test($email.val().trim())),
        setError($phone, !/^[6-9]\d{9}$/.test(phoneDigits)),
        setError($types, $types.find('input:checked').length === 0),
        setError($message, $message.val().trim() === '')
      ];

      if (results.indexOf(false) !== -1) {
        $form.find('.has-error').first().find('input, textarea').first().trigger('focus');
        return;
      }

      var types = $types.find('input:checked').map(function () { return $(this).next('span').text(); }).get();
      $('#cu-support-type').val(types.join(', '));

      var $btn = $form.find('.cu-form__submit').prop('disabled', true);
      var firstName = $name.val().trim().split(/\s+/)[0];

      function done() {
        $('#cu-success-name').text(firstName);
        $('#contact-form').addClass('is-submitted');
        $('#cu-form-success').addClass('show');
      }
      function nativeSubmit() {
        $form.off('submit');
        $form[0].submit();
      }

      fetch($form.attr('action'), { method: 'POST', body: new FormData($form[0]), credentials: 'same-origin' })
        .then(function (res) {
          if (res.url.indexOf('/challenge') !== -1) return nativeSubmit();
          return res.text().then(function (html) {
            if (res.ok && /class="cu-form__success[^"]*\bshow\b/.test(html)) return done();
            nativeSubmit();
          });
        })
        .catch(nativeSubmit)
        .then(function () { $btn.prop('disabled', false); });
    });
  });
})(jQuery);

/* ---------- FAQ accordion (single open at a time) ---------- */
(function ($) {
  'use strict';
  $(function () {
    var $items = $('.sk-faq-item');
    $items.each(function () {
      var $item = $(this);
      var $toggle = $item.find('.js-faq-toggle');
      if (!$toggle.length) return;
      $toggle.on('click', function () {
        var willOpen = !$item.hasClass('open');
        $items.removeClass('open').find('.js-faq-toggle').attr('aria-expanded', 'false');
        if (willOpen) {
          $item.addClass('open');
          $toggle.attr('aria-expanded', 'true');
        }
      });
    });
  });
})(jQuery);
